import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import {
    ActionDialog,
    AlertDialog,
    LoadingTeste,
} from "../base-module/base-component/base.component";
import { BaseActionDialogComponent } from "./base-action-dialog/base-action-dialog.component";
import {
    BaseV2Component,
    LoadingBaseComponent,
} from "./base-component-v2/base-component-v2.component";
import { BaseComponent } from "./base-component/base.component";
import { AuthGuardService } from "./base-service/auth-guard.service";
import { EnderecoService } from "./base-service/endereco.service";
import { PasswordService } from "./base-service/password.service";
import { UsuarioService } from "./base-service/usuario.service";
import { UtilitesService } from "./base-service/utilites.service";

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatDialogModule,
    ],
    declarations: [
        LoadingTeste,
        AlertDialog,
        ActionDialog,
        BaseComponent,
        BaseV2Component,
        LoadingBaseComponent,
        BaseActionDialogComponent,
    ],
    
    providers: [
        
        EnderecoService,
        PasswordService,
        UsuarioService,
        UtilitesService,
        AuthGuardService,
       
    ],
    exports: [
        LoadingTeste,
        AlertDialog,
        ActionDialog,
        LoadingBaseComponent,
        BaseActionDialogComponent,
    ],
})
export class BaseModule {}
